var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 3,
    transform: "translate(3 13)",
    strokeWidth: 0,
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 3,
    transform: "translate(13 3)",
    strokeWidth: 0,
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.038702,9.12961L3,3.999999c0,0,.060984-2.711293,2.538702-2.711298s2.461298,2.711298,2.461298,2.711298v8c0,0,.087722,2.538702,2.538702,2.538702s2.461298-2.538702,2.461298-2.538702v-4.938125",
    transform: "translate(-.038702-.038701)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.57a059369bf7e983456685ee5dccb9f4.svg";
export { ForwardRef as ReactComponent };